import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import Bulma from 'bulma'

import Buefy from 'buefy'
import { routes } from './routes/routes.js'
import VueDraggable from 'vue-draggable'

import wysiwyg from "vue-wysiwyg";

Vue.use(wysiwyg, {
  hideModules: {
    "link": true, "image": true,
    "removeFormat": true,
    "headings": true,
    "code": true,
    "table":true
  }

}); 

Vue.use(VueRouter)
Vue.use(Bulma)
Vue.use(Buefy, {
  defaultIconPack: 'fas',
});
Vue.use(VueDraggable)

Vue.config.productionTip = false

const enrutador = new VueRouter({
  routes: routes,
  mode: "history",
  linkExactActiveClass: "is-active" // active class for *exact* links.
});

enrutador.beforeEach((to, from, next) => {
  console.log(to, from);
  if (from.name !== null) {
    let isAuthenticated = window.localStorage.getItem("token") || undefined;
    if (to.name !== "Login" && !isAuthenticated) {
      next({ name: "Login" });
    } else {
      console.log('next')
      next();
    }
  } else {
      next();
  }
});

export const eventBus = new Vue();

Vue.use(VueResource);
Vue.http.options.root = process.env.VUE_APP_API_URL;
Vue.http.interceptors.push((request, next) => {
  var token = window.localStorage.getItem("token") || undefined;
  if (token) {
    request.headers.set("Authorization", "Bearer" + token);
    request.headers.set("Accept", "application/json");
  }
  next((response) => {
    if (response.status === 0) {
      // enrutador.push("/");
    } else if (response.status === 500) {
      //  enrutador.push('/')
    } else if (response.status === 401) {
      eventBus.$emit("value", true);
    }
  });
});

Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    toast(message, type) {
      this.$buefy.toast.open({
        message: message,
        type: type,
      });
    },
  },
});

new Vue({
  router: enrutador,
  render: (h) => h(App),
}).$mount("#app");
